module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-06-5e90e04819217b9a9046b2616e80175b.jpg";